import styled, { css } from 'styled-components';

import { pxToRem } from '../../../utils/styles';
import { CustomConfigurationType } from './types';

type FontConfiguration = {
  $customConfiguration: CustomConfigurationType;
  $device: string;
  $ellipsis: boolean;
  $inline?: boolean;
  $inlineBlock?: boolean;
  $type: string;
};

export const FontStyle = styled.span<FontConfiguration>`
  &&& {
    font-family: ${({ $device, $type, theme }) =>
      theme.typography[$device][$type].fontFamily};
    font-weight: ${({ $device, $type, theme }) =>
      theme.typography[$device][$type].fontWeight};
    font-size: ${({ $customConfiguration, $device, $type, theme }) =>
      $customConfiguration?.fontSize
        ? pxToRem($customConfiguration?.fontSize)
        : theme.typography[$device][$type].fontSize};
    line-height: ${({ $device, $type, theme }) =>
      theme.typography[$device][$type].lineHeight};
    letter-spacing: ${({ $device, $type, theme }) =>
      theme.typography[$device][$type].letterSpacing};
    color: ${({ $customConfiguration, theme }) =>
      theme.colors[$customConfiguration?.color || 'black']};
    text-decoration: ${({ $device, $type, theme }) =>
      theme.typography[$device][$type].textDecorationLine};
    text-transform: ${({ $customConfiguration, $device, $type, theme }) =>
      $customConfiguration?.textTransform
        ? $customConfiguration?.textTransform
        : theme.typography[$device][$type].textTransform};
    cursor: ${({ $customConfiguration }) =>
      $customConfiguration?.cursor || 'inherit'};
    margin: 0;
    text-align: ${({ $customConfiguration }) =>
      $customConfiguration?.textAlign};
    white-space: ${({ $customConfiguration }) =>
      $customConfiguration?.whiteSpace};
    flex-shrink: ${({ $customConfiguration }) =>
      $customConfiguration?.flexShrink};
    flex-wrap: ${({ $customConfiguration }) => $customConfiguration?.flexWrap};
    opacity: ${({ $customConfiguration }) => $customConfiguration?.opacity};
    text-decoration: ${({ $customConfiguration }) =>
      $customConfiguration?.textDecoration};
    overflow-wrap: ${({ $customConfiguration }) =>
      $customConfiguration?.overflowWrap};
    &:hover {
      color: ${({ $customConfiguration, theme }) =>
        theme.colors[$customConfiguration?.color || 'black']};
    }

    ${({ $ellipsis }) =>
      $ellipsis &&
      css`
        overflow: hidden;
        white-space: nowrap;
        text-overflow: $ellipsis;
      `}

    ${({ $inline }) =>
      $inline &&
      css`
        display: flex;
        align-items: center;
        gap: ${pxToRem(8)};
        justify-content: flex-start;
      `}
  ${({ $inlineBlock }) =>
      $inlineBlock &&
      css`
        display: $inline-block;
      `}
  }
`;
